module.exports = __webpack_public_path__ + "media/svg/Book2-660f511e.svg";